








import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    formulation: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  setup() {
    return {}
  },
})
